import { C, S, fontCond, GENDER, genderColor } from "../constants";
import { Avatar } from "../components/ui";

export default function LoginScreen({
  isMobile,
  // state
  loginUser, loginPass, loginError, loginSugg,
  msg, msgType,
  // setters
  setLoginUser, setLoginPass, setLoginSugg, setScreen, setTab,
  // actions
  handleLoginInput, login,
  // gender
  gender, setGender,
}) {
  return (
    <div style={{
      ...S.app,
      display: "flex", alignItems: "center", justifyContent: "center",
      minHeight: "100vh",
      background: "linear-gradient(135deg, #e8eef5 0%, #f5f7fa 100%)",
      padding: 16,
    }}>
      <div style={{
        width: "100%", maxWidth: 380,
        padding: isMobile ? 28 : 40,
        background: C.card, borderRadius: 20,
        border: "1px solid " + C.border,
        boxShadow: "0 20px 60px rgba(0,0,0,.2)",
      }}>
        {/* Logo + title */}
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div style={{ marginBottom: 12, display: "flex", justifyContent: "center" }}>
            <svg width={56} height={56} viewBox="0 0 16.6 16.6" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
              <path d="M16.6,8.3c0,4.58-3.72,8.3-8.3,8.3S0,12.88,0,8.3,3.72,0,8.3,0s8.3,3.72,8.3,8.3" fill="#005095"/>
              <path d="M8.3,14.11c-3.21,0-5.81-2.6-5.81-5.81S5.09,2.49,8.3,2.49c1.5,0,2.87,.57,3.9,1.5l.88-.88c-1.26-1.16-2.94-1.87-4.78-1.87C4.4,1.24,1.25,4.4,1.25,8.3s3.16,7.06,7.06,7.06c1.84,0,3.52-.71,4.78-1.87l-.88-.88c-1.03,.94-2.4,1.5-3.9,1.5" fill="#ffdc00"/>
              <path d="M8.3,11.62c-1.83,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32c.81,0,1.56,.29,2.13,.78l.88-.88c-.8-.71-1.86-1.14-3.02-1.14-2.52,0-4.57,2.04-4.57,4.57s2.04,4.57,4.57,4.57c1.16,0,2.21-.43,3.02-1.14l-.88-.88c-.58,.48-1.32,.78-2.13,.78" fill="#ffdc00"/>
              <path d="M13.09,8.68c-.27,0-.51-.09-.71-.24-.04-.03-.08-.06-.11-.1-.07-.08-.16-.13-.27-.13-.04,0-.07,0-.1,.02-.07,0-.14,.02-.22,.02-.23,0-.45-.05-.65-.13-.3-2.68-1.85-4.98-4.05-6.32,1.46,1.53,2.35,3.6,2.35,5.87,0,.11,0,.23,0,.34,0,0-1.63,.43-2.17,.6-.09,.03-.26,.09-.35,.13-.47,.2-.85,.58-1.07,1.05,.1,.19,.22,.36,.35,.52h0c.03-.57,.48-1.03,1.05-1.08,.2-.02,.39,.02,.56,.09,.52,.24,1.11,.37,1.74,.37,.67,0,1.33-.14,1.89-.43,.54-.29,1.14-.48,1.77-.54v-.03h0" fill="#fff"/>
            </svg>
          </div>
          <div style={{
            fontFamily: fontCond, fontSize: 14, color: C.muted,
            fontWeight: 600, letterSpacing: 3, marginTop: 8,
          }}>
            RANKING 2026
          </div>
        </div>

        {/* Seletor de divisão: Masculino / Feminino / Legends */}
        <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
          {GENDER.keys.map(g => (
            <button
              key={g}
              style={{
                ...S.genderBtn(gender === g, g),
                flex: 1, padding: "10px 4px", fontSize: 13, borderRadius: 8,
              }}
              onClick={() => setGender(g)}
            >
              {GENDER.emoji[g]} {GENDER.label[g]}
            </button>
          ))}
        </div>

        {/* Name input + autocomplete */}
        <div style={{ position: "relative" }}>
          <input
            style={{ ...S.input, marginBottom: loginSugg.length ? 0 : 10, fontSize: 16 }}
            placeholder="Nome do jogador ou 'admin'"
            value={loginUser}
            onChange={e => handleLoginInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && login()}
            autoComplete="off"
            autoCapitalize="words"
          />
          {loginSugg.length > 0 && (
            <div style={{
              background: C.cardAlt, border: "1px solid " + C.border,
              borderTop: "none", borderRadius: "0 0 8px 8px",
              marginBottom: 10, zIndex: 10, position: "relative",
            }}>
              {loginSugg.map(p => (
                <div
                  key={p.id}
                  style={{
                    padding: "12px 14px", cursor: "pointer", fontSize: 14,
                    color: C.text, borderBottom: "1px solid " + C.border + "44",
                    display: "flex", alignItems: "center", gap: 10, minHeight: 44,
                  }}
                  onMouseDown={() => { setLoginUser(p.name); setLoginSugg([]); }}
                >
                  <Avatar player={p} size={28} />
                  <span style={{ flex: 1 }}>{p.name}</span>
                  <span style={{ color: C.muted, fontSize: 12 }}>#{p.position}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Password input */}
        <input
          style={{ ...S.input, fontSize: 16 }}
          type="password"
          placeholder="Senha"
          value={loginPass}
          onChange={e => setLoginPass(e.target.value)}
          onKeyDown={e => e.key === "Enter" && login()}
        />

        {/* Error */}
        {loginError && (
          <div style={{ color: "#e53e3e", fontSize: 14, marginBottom: 10, fontWeight: 600 }}>
            {loginError}
          </div>
        )}

        {/* Buttons */}
        <button
          style={{ ...S.btn(genderColor(gender)), width: "100%", padding: "14px", fontSize: 15 }}
          onClick={login}
        >
          ENTRAR
        </button>
        <button
          style={{ ...S.btn(C.muted, true), width: "100%", padding: "12px", fontSize: 13, marginTop: 10 }}
          onClick={() => { setScreen("public"); setTab("ranking"); }}
        >
          👁️ Ver ranking sem login
        </button>

        <div style={{ marginTop: 16, fontSize: 12, color: C.muted, textAlign: "center" }}>
          Senha padrão: <b style={{ color: C.text }}>senha123</b>
        </div>
      </div>

      {/* Flash message */}
      {msg && <div style={S.msg(msgType)}>{msg}</div>}
    </div>
  );
}
